import script from "./ContestHead.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestHead.vue?vue&type=script&setup=true&lang=js"

import "./ContestHead.vue?vue&type=style&index=0&id=d9170f5a&lang=scss"

const __exports__ = script;

export default __exports__